import { Clover, Contact, HelpCircle, Home, Menu } from 'lucide-react'
import { parseCookies } from 'nookies'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import logo from '@/assets/logo.png'
import { Button } from '@/components/ui/button'

import { AccountMenu } from './account-menu'
import { NavLink } from './nav-link'
import { ThemeToggle } from './theme-toggle'
import { Separator } from './ui/separator'

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const checkToken = () => {
      const { 'reactAuth.token': token } = parseCookies()
      setIsLoggedIn(!!token)
    }

    checkToken()

    const interval = setInterval(checkToken, 10000)

    return () => clearInterval(interval)
  }, [])

  function toggleMobileMenu() {
    setIsMobileMenuOpen((prev) => !prev)
  }

  function goToHome() {
    navigate('/')
  }

  return (
    <div className="border-b">
      <div className="flex h-16 items-center gap-3 px-4">
        {/* Logo - agora clicável */}
        <button onClick={goToHome} className="flex items-center">
          <img src={logo} alt="Logo" className="h-7 w-auto cursor-pointer" />
        </button>

        {/* Separator Desktop */}
        <Separator orientation="vertical" className="hidden h-5 lg:block" />

        {/* Navegação Desktop */}
        <nav className="hidden items-center space-x-3 lg:flex">
          <NavLink to="/">
            <Home className="h-4 w-4" />
            Início
          </NavLink>
          <NavLink to="/campanhas">
            <Clover className="h-4 w-4" />
            Campanhas
          </NavLink>
          <NavLink to="/perguntas-frequentes">
            <HelpCircle className="h-4 w-4" />
            Perguntas Frequentes
          </NavLink>
          <NavLink to="/contato">
            <Contact className="h-4 w-4" />
            Contato
          </NavLink>
        </nav>

        {/* Spacer para empurrar botão hamburguer para esquerda */}
        <div className="flex-1" />

        {/* Mobile: botão hamburguer */}
        <button onClick={toggleMobileMenu} className="block lg:hidden">
          <Menu className="h-5 w-5" />
        </button>

        {/* ThemeToggle + Login/AccountMenu */}
        <div className="flex items-center gap-2">
          <ThemeToggle />
          {isLoggedIn ? (
            <AccountMenu />
          ) : (
            <Button
              variant="outline"
              onClick={() => (window.location.href = '/sign-in')}
              className="w-32"
            >
              Entrar
            </Button>
          )}
        </div>
      </div>

      {/* Menu Mobile */}
      {isMobileMenuOpen && (
        <div className="flex flex-col gap-2 px-4 pb-4 lg:hidden">
          <NavLink to="/" onClick={() => setIsMobileMenuOpen(false)}>
            <Home className="h-4 w-4" />
            Início
          </NavLink>
          <NavLink to="/campanhas" onClick={() => setIsMobileMenuOpen(false)}>
            <Clover className="h-4 w-4" />
            Campanhas
          </NavLink>
          <NavLink
            to="/perguntas-frequentes"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <HelpCircle className="h-4 w-4" />
            Perguntas Frequentes
          </NavLink>
          <NavLink to="/contato" onClick={() => setIsMobileMenuOpen(false)}>
            <Contact className="h-4 w-4" />
            Contato
          </NavLink>
        </div>
      )}
    </div>
  )
}
